import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { BillingTriggerType } from '~/types/api.model';
import { BillingDayOfMonthModel } from '../BillingDayOfMonth';
import { OneTimeInStagesModel } from '../OneTimeInStagesModel';
import { makeMaxCharges, makeOnApprovalBilling, makeOnDemandBilling, makeOneTimeInStagesBilling, makeOneTimeManualBilling, makeOngoingBilling, makeRepeatableManualBilling } from './makers';
import * as selectors from './selectors';
const maxChargesToAmendmentDTO = (maxCharges)=>({
        enabled: maxCharges.enabled,
        limit: maxCharges.limit
    });
const maxChargesFromAmendmentDTO = (maxCharges)=>{
    var _maxCharges_limit;
    return makeMaxCharges(maxCharges.enabled, (_maxCharges_limit = maxCharges.limit) !== null && _maxCharges_limit !== void 0 ? _maxCharges_limit : undefined);
};
const recurrenceToAmendmentDTO = (billing)=>({
        period: billing.recurrencePeriod,
        billingDayOfMonth: billing.billingDayOfMonth != null ? billing.billingDayOfMonth.toJSON() : null,
        billingDayOfWeek: billing.billingDayOfWeek,
        billingDayOfYear: billing.billingDayOfYear
    });
export function toAmendmentDTO(billing) {
    return selectors.match(billing, {
        onApproval: ()=>({
                trigger: BillingTriggerType.OnApproval
            }),
        oneTimeManual: ()=>({
                trigger: BillingTriggerType.OneTimeManual
            }),
        ongoing: (ongoing)=>({
                trigger: BillingTriggerType.Ongoing,
                ongoing: {
                    recurrence: recurrenceToAmendmentDTO(ongoing),
                    isBilledUpfront: ongoing.isBilledUpfront,
                    maxCharges: maxChargesToAmendmentDTO(ongoing.maxCharges)
                }
            }),
        repeatableManual: (repeatableManual)=>({
                trigger: BillingTriggerType.RepeatableManual,
                repeatableManual: {
                    recurrence: recurrenceToAmendmentDTO(repeatableManual),
                    isBilledUpfront: repeatableManual.isBilledUpfront,
                    maxCharges: maxChargesToAmendmentDTO(repeatableManual.maxCharges)
                }
            }),
        oneTimeInStages: (oneTimeInStages)=>({
                trigger: BillingTriggerType.OneTimeInStages,
                oneTimeInStages: oneTimeInStages.oneTimeInStages.toDTO()
            }),
        onDemand: (onDemand)=>({
                trigger: BillingTriggerType.OnDemand,
                onDemand: {
                    preapprovalPeriod: onDemand.preapprovalPeriod,
                    maxCharges: maxChargesToAmendmentDTO(onDemand.maxCharges)
                }
            })
    });
}
export function fromAmendmentDTO(dto) {
    switch(dto.trigger){
        case BillingTriggerType.OnApproval:
            return makeOnApprovalBilling();
        case BillingTriggerType.OneTimeManual:
            return makeOneTimeManualBilling();
        case BillingTriggerType.Ongoing:
            return makeOngoingBilling(dto.ongoing.recurrence.period, {
                billingDayOfMonth: dto.ongoing.recurrence.billingDayOfMonth != null ? BillingDayOfMonthModel.make(dto.ongoing.recurrence.billingDayOfMonth) : null,
                billingDayOfWeek: dto.ongoing.recurrence.billingDayOfWeek,
                billingDayOfYear: dto.ongoing.recurrence.billingDayOfYear,
                isBilledUpfront: dto.ongoing.isBilledUpfront,
                maxCharges: maxChargesFromAmendmentDTO(dto.ongoing.maxCharges)
            });
        case BillingTriggerType.RepeatableManual:
            return makeRepeatableManualBilling(dto.repeatableManual.recurrence.period, {
                maxCharges: maxChargesFromAmendmentDTO(dto.repeatableManual.maxCharges)
            });
        case BillingTriggerType.OneTimeInStages:
            return makeOneTimeInStagesBilling(OneTimeInStagesModel.fromDTO(dto.oneTimeInStages));
        case BillingTriggerType.OnDemand:
            return makeOnDemandBilling(dto.onDemand.preapprovalPeriod, {
                maxCharges: maxChargesFromAmendmentDTO(dto.onDemand.maxCharges)
            });
    }
}
export function applyBilledUponAmendment(live, amended) {
    switch(live.trigger){
        case BillingTriggerType.Ongoing:
            return amended.trigger === BillingTriggerType.Ongoing ? _object_spread_props(_object_spread({}, amended), {
                isProrated: live.isProrated,
                isPaused: live.isPaused,
                billUpfrontState: live.billUpfrontState
            }) : amended;
        default:
            return amended;
    }
}
